import React from "react"
import OurPeopleComponent from "./OurPeople"
import ourPeopleFactory from "./ourPeople.factory"

export { default as OurPeopleQuery } from "./ourPeople.query"

export const OurPeople = props => {
  const { data } = props
  const componentProps = { ...props, ...ourPeopleFactory.transform(data) }
  return <OurPeopleComponent {...componentProps} />
}
